document.querySelectorAll('[data-discount-copy]').forEach(function (btn) {
  btn.addEventListener('click', function () {
    var code = btn.getAttribute('data-discount-copy');
    var original = btn.textContent;
    function copied() {
      btn.textContent = btn.getAttribute('data-copied-label') || 'Copied!';
      setTimeout(function () { btn.textContent = original; }, 2000);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(copied).catch(function () {
        fallbackCopy(code, btn, copied);
      });
    } else {
      fallbackCopy(code, btn, copied);
    }
  });
});

function fallbackCopy(text, btn, done) {
  var ta = document.createElement('textarea');
  ta.value = text;
  ta.style.position = 'fixed';
  ta.style.opacity = '0';
  document.body.appendChild(ta);
  ta.select();
  try { document.execCommand('copy'); done(); } catch (e) {}
  document.body.removeChild(ta);
}